module.exports = __webpack_public_path__ + "static/img/coupon_empty3@3x.5f18ed10.png";